<script>
  import Badge from '@/components/Ecommerce/Badge'
  import { computed } from '@nuxtjs/composition-api';

  export default {
    name: 'ProductTypeBlock',
    components: {
      Badge
    },
    props: {
      data: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      Link () {
        if(this.data.fields.link.startsWith('http://') || this.data.fields.link.startsWith('https://')) {
          return this.data.fields.link;
        } else {
          return `/${this.data.fields.link}`;
        }
      }
    }
  }
</script>

<template>
  <div
    v-if="data && data.fields"
    class="bg-blue-100 py-3 px-4 rounded"
  >
    <a
      :href="Link"
    >
      <div class="relative product-type-block flex gap-6">
        <img 
          v-if="data && data.fields && data.fields.image"
          :src="data.fields.image.fields.file.url"
          class="w-1/3"
        >
        <div class="flex flex-col justify-center ">
          <Badge 
            v-if="data && data.fields && data.fields.discountText"
            primary
            class="inline mb-2.5 w-max rounded-sm"
          >
            {{ data.fields.discountText }}
          </Badge>
                
          <h3 
            v-if="data && data.fields && data.fields.title"
            class="mb-3 text-2xl leading-7"
          >
            {{ data.fields.title }}
          </h3>
          <span 
            v-if="data && data.fields && data.fields.description"
            class="text-base text-gray-500"
          >
            {{ data.fields.description }}
          </span>
        </div>
      </div>
    </a>
  </div>
</template>
